import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Alert, Spinner, Row, Col, InputGroup, Button, Card, Form, Badge } from 'react-bootstrap';
import { LanguageProvider } from '../../core/language-provider';
import { DataManager } from '../../core/data-manager';
import { ResourceManager } from '../../core/resource-manager';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import { ViewManager } from '../../core/view-manager';
import { Utils } from '../../core/utils';
import CardEventoV2 from '../../components/Card/EventoV2';
import CardCorsoList from '../../components/Card/CorsoList';
import CardPubblicazione from '../../components/Card/Pubblicazione';
import { ApiManager } from '../../core/api-manager';




export default function Search() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');

    const [searchParams, setSearchParams] = useSearchParams();
    const [data, setData] = useState(1);
    const [corsi, setCorsi] = useState(null);
    const [eventi, setEventi] = useState(null);
    const [convegni, setConvegni] = useState(null);
    const [pubblicazioni, setPubblicazioni] = useState(null);
    const [categorie, setCategorie] = useState(null);
    const [limitEventi, setLimitEventi] = useState(3);
    const [limitConvegni, setLimitConvegni] = useState(3);
    const [limitCorsi, setLimitCorsi] = useState(3);
    const [limitPubblicazioni, setLimitPubblicazioni] = useState(3);
    const [search, setSearch] = useState("");
    const [typeCategory, setTypeCategory] = useState(searchParams.get("type") ? searchParams.get("type") : "0");
    const [category, setCategory] = useState(searchParams.get("category") ? [searchParams.get("category")] : []);
    const isMobile = window.innerWidth < 768;





    useEffect(() => {
        getCorsiV2();
        getEventiV2();
        getConvegniV2();
        getPubblicazioniV2();
        getCategorie();
    }, []);



    useEffect(() => {
        getCorsiV2();
    }, [limitCorsi]);

    useEffect(() => {
        getEventiV2();
    }, [limitEventi]);

    useEffect(() => {
        getConvegniV2();
    }, [limitConvegni]);

    useEffect(() => {
        getPubblicazioniV2();
    }, [limitPubblicazioni]);




    async function doSearch() {
        getCorsiV2();
        getConvegniV2();
        getEventiV2();
        getPubblicazioniV2();
        getCategorie()
    }


    function changeCategory(e) {
        if (e === "0") {
            setCategory([])
        } else {
            setCategory([e])
        }
    }

    async function getCorsiV2() {
        if (category.length === 0) {
            var body = {
                limit: limitCorsi,
                query: search,
                category: null,
                offset: null,
                idAssociation: null
            }
        } else {
            var body = {
                limit: limitCorsi,
                query: search,
                category: category.toString(),
                offset: null,
                idAssociation: null
            }
        }
        var response = await ApiManager.sendAuthenticatedRequest('/custom/get_courses', body)
        if (response.success === 1) {
            var t = response.body
            setCorsi(t)
        } else {
            setCorsi([])
        }
    }


    async function getPubblicazioniV2() {
        if (category.length === 0) {
            var body = {
                limit: limitPubblicazioni,
                query: search,
                category: null,
                price: null,
                offset: null
            }
        } else {
            var body = {
                limit: limitPubblicazioni,
                query: search,
                category: category.toString(),
                price: null,
                offset: null
            }
        }
        var response = await ApiManager.sendAuthenticatedRequest('/custom/get_publication', body)
        if (response.success === 1) {
            var t = response.body
            setPubblicazioni(t)
        } else {
            setPubblicazioni([])
        }
    }


    async function getEventiV2() {
        if (category.length === 0) {
            var body = {
                limit: limitEventi,
                query: search,
                category: null,
                offset: null
            }
        } else {
            var body = {
                limit: limitEventi,
                query: search,
                category: category.toString(),
                offset: null
            }
        }
        var response = await ApiManager.sendAuthenticatedRequest('/custom/get_events', body)
        if (response.success === 1) {
            var t = response.body
            setEventi(t)
        } else {
            setEventi([])
        }
    }



    async function getConvegniV2() {
        if (category.length === 0) {
            var body = {
                limit: limitConvegni,
                query: search,
                category: null,
                offset: null
            }
        } else {
            var body = {
                limit: limitConvegni,
                query: search,
                category: category.toString(),
                offset: null
            }
        }
        var response = await ApiManager.sendAuthenticatedRequest('/custom/get_convegni', body)
        if (response.success === 1) {
            var t = response.body
            setConvegni(t)
        } else {
            setConvegni([])
        }
    }


    async function getCategorie() {
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var response = await DataManager.getItems('category', 1, 100, sorting)
        if (response.success === 1) {
            console.log(response)
            setCategorie(response.body)
        }
    }

    function clickPublication(id) {
        navigate('/pubblicazioni/' + id)
    }



    if (data) {
        return (
            <>
                <Helmet>
                    <title>{LanguageProvider.get('header.ricerca')}</title>
                </Helmet>


                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <Container fluid className='text-white' style={{ backgroundColor: 'var(--secondary-color)', height: '100%' }}>
                    <Container fluid={'md'}>
                        <Row style={{ color: 'var(--primary-color)' }} className='py-5'>
                            <Col>
                                <h2 style={isMobile ? { color: 'var(--primary-color)', fontSize: '45px' } : { color: 'var(--primary-color)' }}>{LanguageProvider.get('ricerca.titolo')}</h2>
                                <h6 style={{ maxWidth: 600 }}>{LanguageProvider.get('ricerca.sottotitolo')}</h6>
                            </Col>
                        </Row>
                        <Row className='align-items-end'>
                            <Col xs={12} md={3} className='pb-2 pb-md-5'>
                                <Form.Label style={{ color: 'var(--primary-color)' }}>Categorie</Form.Label>
                                <Form.Select aria-label="Default select example" className='rounded-pill' onChange={(e) => { changeCategory(e.target.value) }} value={category}>
                                    <option value="0">Tutte le categorie</option>
                                    {categorie && categorie.map((categoria, i) => {
                                        return (
                                            <option key={i} value={categoria.id}>{categoria.name}</option>
                                        )
                                    })}

                                </Form.Select>
                            </Col>
                            <Col xs={12} md={3} className='pb-2 pb-md-5'>
                                <Form.Label style={{ color: 'var(--primary-color)' }}>Tipologie</Form.Label>
                                <Form.Select aria-label="Default select example" className='rounded-pill' onChange={(e) => setTypeCategory(e.target.value)} value={typeCategory}>
                                    <option value="0">Tutte le tipologie</option>
                                    <option value="1">Corso</option>
                                    <option value="2">Seminario</option>
                                    <option value="3">Pubblicazione</option>
                                    <option value="4">Convegno</option>
                                </Form.Select>
                            </Col>
                            <Col xs={12} md={3} className='pb-2 pb-md-5'>
                                <Form.Label style={{ color: 'var(--primary-color)' }}>Parole chiave</Form.Label>
                                <InputGroup>
                                    <Form.Control style={{ borderStartStartRadius: '20px', borderBottomLeftRadius: '20px', borderRight: '0' }}
                                        placeholder="Cerca" onChange={(e) => setSearch(e.target.value)}
                                    />
                                    <InputGroup.Text style={{ borderTopRightRadius: '20px', borderBottomRightRadius: '20px', borderLeft: '0', backgroundColor: 'white' }}>
                                        <FontAwesomeIcon icon='search'></FontAwesomeIcon></InputGroup.Text>
                                </InputGroup>
                            </Col>
                            <Col className='pb-5'>
                                <Button className='rounded-pill px-3' onClick={() => doSearch()}>Cerca<FontAwesomeIcon icon='search' className='ms-2'></FontAwesomeIcon></Button>
                            </Col>
                        </Row>
                    </Container>

                </Container>

                {typeCategory === "0" || typeCategory === "1" ? <> <Container fluid>
                    <Container fluid='md' className='mt-5 mb-5'>
                        <Row className='align-items-center mb-3'>
                            <Col>
                                <h3 style={isMobile ? { color: 'var(--primary-color)', fontSize: '40px' } : { color: 'var(--primary-color)' }}>{LanguageProvider.get('ricerca.corsi')}</h3>
                            </Col>
                            <Col className='text-end'>
                                <Button onClick={() => navigate('/corsi')} variant='light' style={{ borderRadius: '20px', color: 'var(--primary-color)', borderColor: 'var(--primary-color)' }}>Tutti i corsi<FontAwesomeIcon icon='arrow-right' className='ms-2'></FontAwesomeIcon></Button>
                            </Col>
                        </Row>
                        <Row className='mb-5'>
                            {corsi && corsi.map((corso, index) => {
                                return (
                                    <>
                                        <Col md={4} xs={12}>
                                            <CardCorsoList data={corso} key={index}></CardCorsoList>
                                        </Col>
                                    </>)
                            })}

                            {corsi && corsi.length === 0 ? <>
                                <Alert>Nessun corso trovato!</Alert></> : <></>}

                        </Row>
                        {corsi && corsi.length > 0 ? <>
                            <Row className='mt-3 text-center'>
                                <Col>
                                    <Button className='rounded-pill px-3' onClick={() => { setLimitCorsi(limitCorsi + 3) }}>Mostra altri risultati</Button>
                                </Col>
                            </Row></> : <></>}

                    </Container>
                </Container></> : <></>}



                {typeCategory === "0" || typeCategory === "2" ? <><Container fluid>
                    <Container fluid='md' className='mt-5 mb-5'>
                        <Row className='align-items-center mb-3'>
                            <Col>
                                <h3 style={isMobile ? { color: 'var(--primary-color)', fontSize: '40px' } : { color: 'var(--primary-color)' }}>{LanguageProvider.get('ricerca.eventi')}</h3>
                            </Col>
                            <Col className='text-end'>
                                <Button onClick={() => navigate('/eventi')} variant='light' style={{ borderRadius: '20px', color: 'var(--primary-color)', borderColor: 'var(--primary-color)' }}>Tutti gli eventi<FontAwesomeIcon icon='arrow-right' className='ms-2'></FontAwesomeIcon></Button>
                            </Col>
                        </Row>
                        <Row className='justify-content-between mb-5'>
                            {eventi && eventi.map((evento, index) => {
                                return (
                                    <>
                                        <Col md={4} xs={12}>
                                            <CardEventoV2 data={evento} key={index}></CardEventoV2>
                                        </Col>
                                    </>)
                            })}
                            {eventi && eventi.length === 0 ? <>
                                <Alert>Nessun evento trovato!</Alert></> : <></>}


                        </Row>
                        {eventi && eventi.length > 0 ? <>
                            <Row className='mt-3 text-center'>
                                <Col>
                                    <Button className='rounded-pill px-3' onClick={() => { setLimitEventi(limitEventi + 2) }}>Mostra altri risultati</Button>
                                </Col>
                            </Row></> : <></>}

                    </Container>
                </Container>
                </> : <></>}



                {typeCategory === "0" || typeCategory === "4" ? <><Container fluid>
                    <Container fluid='md' className='mt-5 mb-5'>
                        <Row className='align-items-center mb-3'>
                            <Col>
                                <h3 style={isMobile ? { color: 'var(--primary-color)', fontSize: '40px' } : { color: 'var(--primary-color)' }}>{LanguageProvider.get('ricerca.convegni')}</h3>
                            </Col>
                            <Col className='text-end'>
                                <Button onClick={() => navigate('/eventi')} variant='light' style={{ borderRadius: '20px', color: 'var(--primary-color)', borderColor: 'var(--primary-color)' }}>Tutti i convegni<FontAwesomeIcon icon='arrow-right' className='ms-2'></FontAwesomeIcon></Button>
                            </Col>
                        </Row>
                        <Row className='justify-content-between mb-5'>
                            {convegni && convegni.map((evento, index) => {
                                return (
                                    <>
                                        <Col md={4} xs={12}>
                                            <CardEventoV2 data={evento} key={index}></CardEventoV2>
                                        </Col>
                                    </>)
                            })}
                            {convegni && convegni.length === 0 ? <>
                                <Alert>Nessun seminario trovato!</Alert></> : <></>}


                        </Row>
                        {convegni && convegni.length > 0 ? <>
                            <Row className='mt-3 text-center'>
                                <Col>
                                    <Button className='rounded-pill px-3' onClick={() => { setLimitEventi(limitEventi + 2) }}>Mostra altri risultati</Button>
                                </Col>
                            </Row></> : <></>}

                    </Container>
                </Container>
                </> : <></>}


                {typeCategory === "0" || typeCategory === "3" ? <>
                    <Container fluid>
                        <Container fluid='md' className='mt-5 mb-5'>
                            <Row className='align-items-center mb-3'>
                                <Col>
                                    <h3 style={isMobile ? { color: 'var(--primary-color)', fontSize: '40px' } : { color: 'var(--primary-color)' }}>{LanguageProvider.get('ricerca.pubblicazioni')}</h3>
                                </Col>
                                <Col className='text-end'>
                                    <Button onClick={() => navigate('/pubblicazioni')} variant='light' style={{ borderRadius: '20px', color: 'var(--primary-color)', borderColor: 'var(--primary-color)' }}>Tutti le pubblicazioni<FontAwesomeIcon icon='arrow-right' className='ms-2'></FontAwesomeIcon></Button>
                                </Col>
                            </Row>
                            <Row>
                                {pubblicazioni && pubblicazioni.map((pubblicazione, index) => {
                                    return (<Col xs={12} md={4} key={index} className='mb-4'>
                                        {/* <Card role="button" onClick={() => clickPublication(pubblicazione.id)} className='mt-3 mb-3 text-dark h-100 p-2' style={{ borderRadius: '20px', backgroundColor: '#f7f7f7' }}>
                                            <Card.Body>
                                                <div className='d-flex items-align-center'>
                                                    <div>
                                                        <FontAwesomeIcon style={{ color: 'var(--primary-color)' }} icon='bookmark' size='xl'></FontAwesomeIcon>
                                                    </div>
                                                    <div className='ms-2'>
                                                        <p style={{ color: 'var(--primary-color)' }}>Pubblicazione</p>
                                                    </div>
                                                </div>
                                                <h5 style={{ color: 'var(--primary-color)' }}>{pubblicazione.title}</h5>
                                                <Card.Text style={{ minHeight: '70px' }}>
                                                    {pubblicazione && pubblicazione.content && (
                                                        <>
                                                            <span dangerouslySetInnerHTML={{ __html: pubblicazione.content }} style={{
                                                                display: '-webkit-box',
                                                                WebkitBoxOrient: 'vertical',
                                                                overflow: 'hidden',
                                                                WebkitLineClamp: 3
                                                            }}></span>
                                                        </>
                                                    )}
                                                </Card.Text>
                                                <Card.Text>
                                                    <small>{moment(pubblicazione.publicationDate).format('MMMM YYYY')}</small>
                                                </Card.Text>
                                            </Card.Body>
                                        </Card> */}
                                        <CardPubblicazione data={pubblicazione}></CardPubblicazione>
                                    </Col>)
                                })}
                                {pubblicazioni && pubblicazioni.length === 0 ? <>
                                    <Alert>Nessuna pubblicazione trovata!</Alert></> : <></>}

                            </Row>
                            {pubblicazioni && pubblicazioni.length > 0 ? <>
                                <Row className='mt-3 text-center'>
                                    <Col>
                                        <Button className='rounded-pill px-3' onClick={() => { setLimitPubblicazioni(limitPubblicazioni + 3) }}>Mostra altri risultati</Button>
                                    </Col>
                                </Row></> : <></>}


                        </Container>
                    </Container>
                </> : <></>}


            </>
        )

    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }
};